module.exports = __webpack_public_path__ + "images/subscribe-button-arrow.svg";